import { getDateString, getTimezoneAbbr } from 'js/lib/DateUtils';
import { Log } from 'js/components/data_flows/cards/FlowRunLogs/types';

export const getLogCopyText = (log: Log): string => {
  const timezone = getTimezoneAbbr();
  const ts = log.timestamp
    ? `[${getDateString(log.timestamp, 'YYYY-MM-DD HH:mm:ss')} ${timezone}]`
    : '';
  const sev = log.severity ? ` ${log.severity}` : '';
  const res =
    log.resource_type && log.resource_id ? ` [${log.resource_type} ${log.resource_id}]` : '';
  const msg = log.log ? ` ${log.log}` : '';
  return `${ts}${sev}${res}${msg}`.trim();
};

export const getLogsExportText = (logs: Log[]): string => logs.map(getLogCopyText).join('\n');
